export default __webpack_public_path__ + "static/media/ubaLogo.93048b79.png";